import "@kluntje/polyfills/legacy";
import { App } from "Core/App";

window._zhoApp = new App(); // initialize App
